<button class="dark-mode" (click)="switchTheme()">
    <mat-icon class="dark-mode-moon">nightlight_round</mat-icon>
</button>
